<!--  -->
<template>
  <div>
    <el-popover v-model="isVisible" @show="showPopover" placement="bottom" width="550" ref="tenantPopover" trigger="focus">
      <div v-if="addressData.length != 0" class="tenant-pop-up">
        <el-tree class="elTree" node-key="code" :accordion="true" :data="addressData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        <div class="tenant-box">
          <div class="tenant-box-item" @click="selectData(item)" v-for="item in tenantInfo" :key="item.id">
            {{ item.name }}
          </div>
          <div v-if="tenantInfo.length == 0">暂无数据</div>
        </div>
      </div>
      <div v-else>暂无数据</div>
      <!-- <el-input slot="reference" v-model="user.tenant_name" placeholder="请输入内容" @focus="focusInput" @blur="blurInput" @input="inputIng" clearable></el-input> -->
      <el-input slot="reference" v-model="data.inputData" :placeholder="`请输入`" @focus="focusInput" @blur="blurInput" @input="inputIng" @clear="inputClear" :size="data.inputSize" :clearable="data.clearable?data.clearable:false" :disabled="data.disabled"></el-input>
    </el-popover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTenantOpts, getAddrByTenant } from '@/api.js';
export default {
  props:{
    data:{
      type:Object,
      default:function(){
        return {
          inputData:'',
          clearable:true,
          disabled:false,
          inputSize:'medium',
          status:undefined
        }
      }
    }
  },
  data() {
    return {
      isVisible:false,
      addressData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      tenantInfo: [],
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  created() {
    this.getAddrByTenantFun()
    this.getTenantOptsFun()
  },
  methods: {
    // 当用户点击清除时：
    inputClear(){
      this.$emit('inputClear')
    },
    // 当用户选择数据时：
    selectData(data){
      this.$refs.tenantPopover.doClose();
      this.$emit('clickTenant',data)
    },
    // 获取租户用户选项
    getAddrByTenantFun() {
      this.$request('get', getAddrByTenant, { 
        status: this.data.status,
        user_type: this.data.user_type,
      }).then((res) => {
        this.addressData = res;
      });
    },
    // 当popover显示时
    showPopover(){
      // this.tenantInfo = this.tenantInfoAll
    },
    // 当点击区域时，获取租户
    handleNodeClick(data, node) {
      let newData = {
        status: this.data.status,
      };
      const firstLevelIsCountry = this.addressData[0]['is_country']
      if (node.level == 1) {
        const key = firstLevelIsCountry ? 'country' : 'province'
        newData[key] = data.code;
      } else if (node.level == 2) {
        const key = firstLevelIsCountry ? 'province' : 'city'
        newData[key] = data.code;
      } else if (node.level == 3) {
        const key = firstLevelIsCountry ? 'city' : 'area'
        newData[key] = data.code;
      }
      this.getTenantOptsFun(newData);
    },
    getTenantOptsFun(data) {
        this.$request('get', getTenantOpts, {...data,user_type: this.data.user_type,},{silence:true}).then((res) => {
        if(!data){
          this.tenantInfoAll = res
        }
        this.tenantInfo = res;
      });
    },
    // 输入框聚焦时：
    focusInput() {
      this.$refs.tenantPopover.doShow();
    },
    // 输入框失焦时：
    blurInput() {
      this.$refs.tenantPopover.doClose();
    },
    // 当用户输入时
    inputIng() {
      // if(!this.isVisible){ //当弹框关闭时清除输入框内容，不用调用接口
      //   return
      // }
      this.getTenantOptsFun({
        name: this.data.inputData,
      });
    },
  },
};
</script>

<style scoped>
.tenant-pop-up {
  display: flex;
}
.tenant-box {
  border-left: 1px solid #444;
  padding-left: 10px;
  margin-left: 10px;
  height: 400px;
  overflow: scroll;
  width: 70%;
}
.tenant-box-item {
  color: #444;
  font-size: 15px;
  cursor: pointer;
  padding: 5px;
}
.tenant-box-item:hover {
  background: #eee;
}
.elTree{
  width: 25%;
}
</style>
